import React from "react";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import projectLogo from "../beast-logo.png";
import BeastNavbar from "../components/BeastNavbar";
import databaseOverview from "../database-overview.png";
import homePageFooter from "../home-page-footer.png";
import "../main.scss";

import Container from "react-bootstrap/Container";
import Stack from "react-bootstrap/Stack";
import Row from "react-bootstrap/Row";

const AboutPage = () => {
  // const { showNotification } = mfe.useContext('CoreNotifications')

  // const showBasicNotification = () => {
  //   showNotification({message: 'Hello! I\'m a basic notification!'})
  // }

  return (
    <div className="App">
      <BeastNavbar selected="home"/>
      <div className="pt-3 wrapper">
      
        <h1>Welcome to BEAST DB!</h1>
        
        <p>
          <i>
            Enabling rational understanding and design of electrocatalysts
            through state-of-the-art theory
          </i>
        </p>      
        
        <br/>
        
        <div className="wrapper-narrow">
          <img src={homePageFooter} style={{ width: "100%" }}/>
        </div>
        
        <br/>

        <div className="wrapper-narrow" style={{ "textAlign": "left" }}>
          The <b>B</b>eyond-DFT <b>E</b>lectrochemistry with <b>A</b>ccelerated
          and <b>S</b>olvated <b>T</b>echniques Database, or BEAST DB, contains
          thousands of electrocatalysis calculations and visualizations of
          properties that help rationalize observed behavior
          and design more effective catalysts.
        </div>
        
        <br/>

        <div className="pb-3 wrapper-narrow">
          <img src={databaseOverview} style={{ width: "70%" }} />
        </div>
        
      </div>
    </div>
  );
};

export default AboutPage;
